import { useState } from "react";
import type { InviteLink } from "@omts/shared";
import { api } from "../../api";
import { useAuth } from "../../auth";
import { InviteResult, TelegramTag, errMsg } from "./common";

/** Личный Telegram текущего пользователя (уведомления логисту/админу). */
export function ProfileTab() {
  const { user } = useAuth();
  const [invite, setInvite] = useState<InviteLink | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const getLink = async () => {
    setBusy(true);
    setError(null);
    try {
      setInvite(await api.telegramInvite());
    } catch (e) {
      setError(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <section className="card">
        <h3 style={{ marginTop: 0 }}>Мой Telegram для уведомлений</h3>
        <dl className="props">
          <dt>Пользователь</dt>
          <dd>
            {user?.fullName} · {user?.email}
          </dd>
          <dt>Telegram</dt>
          <dd>
            <TelegramTag linked={user?.telegramLinked ?? false} />
          </dd>
        </dl>
        <p className="hint">
          Бот присылает: первую ставку по вашей заявке, завершение торгов, автопродление, документы победителя, «нет ставок за 2 часа до
          дедлайна». Ссылка одноразовая; если Telegram уже подключён, новая ссылка перепривяжет аккаунт.
        </p>
        <div className="form-actions" style={{ margin: "8px 0 12px" }}>
          <button className="btn primary" onClick={() => void getLink()} disabled={busy}>
            {busy ? "…" : "Получить ссылку на бота"}
          </button>
        </div>
        {error && <p className="error">{error}</p>}
        {invite && <InviteResult invite={invite} hint="Откройте её в Telegram и нажмите «Start»." />}
      </section>
    </>
  );
}
